export default {
  updateDetails(data) {
    data.TotalItems = 0;

    for (const item of data.Items) {
      data.TotalItems += item.Quantity;
    }
  },
}